import { DOCTOR_NOW_COMPANY_LATITUDE, DOCTOR_NOW_COMPANY_LONGITUDE } from '@/constants/map';
import { GetAddressByLocationQuery, SearchKoreaAddressV2Query } from '@/types/bff/gql-schema';
import { Nullable } from '@/types/common';
import { AddressByLocation, SearchKoreaAddressV2Vo, UserCoordinate, UserSigunguDongli } from '@/types/hospital';

export class SearchHospitalService {
  static updateCoordinate(coordinate: UserCoordinate, updatedCoordinate: UserCoordinate): UserCoordinate {
    return {
      ...coordinate,
      ...updatedCoordinate,
    };
  }

  static initializeUserSigunguDongli(): UserSigunguDongli {
    return {
      sigungu: '서초구',
      dongLi: '서초동',
    };
  }

  static initializeUserCoordinate(): UserCoordinate {
    return {
      latitude: DOCTOR_NOW_COMPANY_LATITUDE,
      longitude: DOCTOR_NOW_COMPANY_LONGITUDE,
    };
  }

  private static parseGetAddressByLocation(data: GetAddressByLocationQuery): Nullable<AddressByLocation> {
    if (!data.getAddressByLocation) {
      return null;
    }

    return {
      ...data.getAddressByLocation,
    };
  }

  static parseHospitalAddressByLocation(data: GetAddressByLocationQuery): UserSigunguDongli {
    const hospitalAddress = SearchHospitalService.parseGetAddressByLocation(data);

    if (!hospitalAddress) {
      return SearchHospitalService.initializeUserSigunguDongli();
    }
    return {
      sigungu: hospitalAddress.sigungu,
      dongLi: hospitalAddress.dongLi,
    };
  }

  static parseKoreaAddressV2(data: SearchKoreaAddressV2Query): SearchKoreaAddressV2Vo[] {
    return data.searchKoreaAddressV2.map((address) => ({
      ...address,
    }));
  }
}
